import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Button } from "@mantine/core";
import { getSelf } from "../../data/actions/personActions";

const nonSelect: React.CSSProperties = {
  userSelect: "none" /* supported by Chrome and Opera */,
  WebkitUserSelect: "none" /* Safari */,
  KhtmlUserSelect: "none" /* Konqueror HTML */,
  MozUserSelect: "none" /* Firefox */,
  msUserSelect: "none" /* Internet Explorer/Edge */,
};

interface ServerErrorProps {
  error?: string | null;
  code?: string | null;

  actions: { getSelf: () => void };
}

const ServerErrorComponent: React.FunctionComponent<ServerErrorProps> = ({
  error,
  code,
  actions,
}) => {
  let children: React.ReactNode | null = null;

  if (code && code == "500") {
    children = (
      <>
        <h1>500</h1>
        {error && (
          <p style={{ width: "fit-content", margin: "auto" }}>
            <em>{error}</em>
          </p>
        )}
        <p style={{ width: "fit-content", margin: "auto" }}>
          An internal error has occurred, please try again later.
        </p>
      </>
    );
  } else {
    children = (
      <>
        <h1>Oops!</h1>
        <p style={{ width: "fit-content", margin: "auto" }}>
          We&apos;re completing some routine maintenance, we&apos;ll be back
          soon!
        </p>
        {code && (
          <p style={{ width: "fit-content", margin: "auto" }}>
            Code:
            {code}
          </p>
        )}
        {error && (
          <p style={{ width: "fit-content", margin: "auto" }}>
            <em>{error}</em>
          </p>
        )}
      </>
    );
  }

  return (
    <>
      <h4
        style={{
          ...nonSelect,
          position: "absolute",
          left: "40px",
          top: "40px",
          color: "darkgray",
        }}
      >
        Stadium Supervisor
      </h4>
      <div
        style={{
          width: "fit-content",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "100px",
          padding: "40px",
        }}
      >
        {children}
        <br />
        <div
          style={{
            width: "fit-content",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Button
            style={{ margin: "auto" }}
            variant="outline"
            onClick={() => actions.getSelf()}
          >
            Try again
          </Button>
        </div>
      </div>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getSelf }, dispatch),
  };
}

const ServerError = connect(null, mapDispatchToProps)(ServerErrorComponent);
export default ServerError;
